import { render, staticRenderFns } from "./EditBlockNavigationTabStyle.vue?vue&type=template&id=7d4b042a&scoped=true&"
import script from "./EditBlockNavigationTabStyle.vue?vue&type=script&lang=js&"
export * from "./EditBlockNavigationTabStyle.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockNavigationTabStyle.vue?vue&type=style&index=0&id=7d4b042a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b042a",
  null
  
)

export default component.exports